import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';

import { getApps } from '../redux/ducks/storeDuck';
import { loggedValidation } from '../redux/ducks/userDuck';

import Container from '../components/Container';
import Header from '../components/Header';
import Text from '../components/Text';
import GridContainer from '../components/GridContainer';
import AppCard from '../components/AppCard';


function Applications({
  getApps, apps, loggedValidation,
}) {
  useEffect(() => {
    loggedValidation();
    getApps();
  }, [apps.length]);


  return (
    <Container bgColor="light">
      <Header />
      <Text placement="center" level="h1" textColor="highlight">
        PagaTodo AppStore
      </Text>
      <GridContainer className="apps-container">
        <div className="grid-horizontal-application-screen">
          {
            apps.map((app, index) => {
              const versions = app.versions;
              const lastVersion = versions && versions[0] ? versions.reverse()[0] : {};
              console.log('LAST', lastVersion)
              return (
                <AppCard
                  key={`app-${index}`}
                  id={app.id}
                  icon={app.icon}
                  appName={app.name}
                  so={app.so}
                  description={app.short_description}
                  file={lastVersion.file_url}
                  versions={versions}
                />
              )
            })
          }
        </div>
      </GridContainer>
    </Container>
  );
}

function mapStateToProps({ store }) {
  return {
    apps: store.apps,
  }
}

export default connect(
  mapStateToProps, {
    getApps,
    loggedValidation,
  }
)(memo(Applications));
